import Head from '../components/Header/Head';
import { FAQ_ITEMS } from '../components/Landing/Faq';
import LandingPage from '../components/Landing/LandingPage';
import { GET_MINIMAL_POSTS } from '../helpers/graphql/posts';
import { GET_USER_COUNT } from '../helpers/graphql/userCount';
import ssrGraphQLClient from '../helpers/ssrGraphQLClient';
import withApollo from '../lib/withApollo';

const Landing = ({ featuredPosts, userCount }) => {
  return (
    <>
      <Head
        justTitle="Start a Travel Blog – Beautiful, Fast & Profitable | TravelFeed"
        feedUrl="featured"
        description="A beautiful travel blog on your own domain. Maps and destination pages build themselves, readers arrive from day one, and earning is built in. No plugins, no maintenance. From $19/year."
        seo={{ canonicalUrl: 'https://travelfeed.com' }}
        faq={FAQ_ITEMS.map(item => ({
          questionName: item.question,
          acceptedAnswerText: item.answer,
        }))}
      />
      <LandingPage featuredPosts={featuredPosts} userCount={userCount} />
    </>
  );
};

export default withApollo(Landing);

export async function getStaticProps() {
  let featuredPosts = [];
  let userCount = null;
  try {
    const res = await ssrGraphQLClient(GET_MINIMAL_POSTS, {
      limit: 6,
      language: 'en',
      orderby: 'createdAt',
      minScore: 14000,
    });
    if (res && res.posts) featuredPosts = res.posts;
  } catch (err) {
    // Landing page works without live posts — the strip falls back gracefully.
  }
  try {
    const res = await ssrGraphQLClient(GET_USER_COUNT, {});
    if (res && res.userCount) userCount = res.userCount;
  } catch (err) {
    // Fallback count is handled in the Hero component.
  }
  return {
    props: { featuredPosts, userCount },
    revalidate: 3600,
  };
}
